import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { SsoService } from '../services/sso.service';
import { selectIsPendoInitialised } from '../store';

@Component({
  selector: 'ets-sne-v2',
  templateUrl: './sne-v2.component.html',
  styleUrls: ['./sne-v2.component.scss']
})
export class SneV2Component implements OnInit {
  constructor(private store: Store, private ssoService: SsoService) {}
  ngOnInit() {
    this.store
      .select(selectIsPendoInitialised)
      .subscribe(async (isPendoInitialised) => {
        if (!isPendoInitialised) {
          await this.ssoService.initialisePendo();
        }
      });
  }
}
